module.exports = __webpack_public_path__ + "static/media/produzioni1.50c70096.png";